import './style.scss';
import { FC } from 'react';
import { ApartmentCardProps } from '../apartmentCard.types';

const ApartmentCardView: FC<ApartmentCardProps> = ({ room, index }) => (
  <div className="apartmentCardContent">
    <div>
      <h2 className="apartmentCardTitle">{room.name}</h2>
      <p className="apartmentCardDesc">
        Cozy apartment near the metro station next to opera housse
      </p>
    </div>
    <div className="apartmentCardFooter">
      <div className="apartmentCardFooterCell">
        <p className="apartmentCardPrice">
          {room.price} FTN <span>/ night</span>
        </p>
        <p className="apartmentCardDate">Nov 14-19</p>
      </div>
      <div className="apartmentCardFooterCell">
      <p className="apartmentRating">
          <i className="icon-star" />
          4.92 (34)
        </p>
      </div>
    </div>
  </div>
);

export default ApartmentCardView;
